import React, {Component} from 'react';

import { Link } from 'react-router-dom';

export default class TripWaitingScale extends Component {

    render() {
        return (
            <div>
                <div className={"trip-section"}>
                    <div className={"trip-section-title"}>{this.props.title}</div>
                    <div className={"row no-padding thin-row margin-top-10"}>
                        <div className={"col s12"}>
                            <div className={"waiting-continer valign-wrapper w100"}>
                                <p className={"w100 center"}>
                                    {this.props.message}
                                    <br />
                                    <i className="material-icons">more_horiz</i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <Link to={'/'} className={`btn btn-shell-empty z-depth-0 text-center`}>
                            Volver
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripWaitingScale.js